import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Campaign} from 'utils/types';
import {itemEndpoints} from '../item/slice';
import ApiService from 'redux/services/api-service';

export interface Navigation {
  contextCampaign?: Campaign;
}
export const navigationEndpoints = {
  sendMessage: createAsyncThunk('navigation/sendMessage', async (payload: any) => {
    const response = await ApiService.post('/contact_us/', payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }),
  getSupportTicketTypes: createAsyncThunk('navigation/getSupportTicketTypes', async () => {
    const response = await ApiService.get('/support_ticket_types/');
    return response.data;
  }),
};
export const navigationSlice = createSlice({
  name: 'navigation',
  initialState: {
    contextCampaign: undefined,
  } as Navigation,
  reducers: {
    // Invoked when new campaign has different identifier so other slices should clear their state
    setContextCampaign(state, {payload}: PayloadAction<Campaign | null>) {
      state.contextCampaign = payload || undefined;
    },
    // Invoked when campaign identifier is the same
    updateContextCampaign(state, {payload}: PayloadAction<Campaign | null>) {
      if (payload?.id !== state.contextCampaign?.id) {
        console.log(
          'updateContextCampaign: rejecting update: campaign id mismatch. Did the context campaign change?',
          payload?.id,
          state.contextCampaign?.id,
        );
        return;
      }
      state.contextCampaign = payload || undefined;
    },
  },
  extraReducers: builder => {
    builder.addCase(itemEndpoints.updateItemBulk.fulfilled, state => {
      if (state.contextCampaign) {
        state.contextCampaign.data_flags.is_per_store_sales_calculation_required = true;
        state.contextCampaign.data_flags.is_per_store_sales_rollup_calculation_required = true;
        state.contextCampaign.data_flags.is_per_item_sales_calculation_required = true;
      }
    });
  },
});

export const navigationActions = navigationSlice.actions;

export type NavigationSlice = {
  [navigationSlice.name]: ReturnType<(typeof navigationSlice)['reducer']>;
};

export const navigationSelectors = {
  // useContextCampaign: () => useAppSelector(state => state.navigation.contextCampaign),
};
